import { resolvePrices } from './TvComparisonPriceUtil';
import { focusAndScroll } from './TvComparisonFocusUtil';
const DEFAULT_VISIBLE_CHANNELS_COUNT = 10;
export const createChannelsMap = (channels) => {
    const channelsMap = {};
    channels.forEach((channel) => (channelsMap[channel.id] = channel));
    return channelsMap;
};
export const createChannelsGroup = (props) => {
    var _a;
    const { channels, translate, isAllShown, filterActions, shownItemsCount, labelKey } = props;
    const visibleChannelsCount = shownItemsCount || DEFAULT_VISIBLE_CHANNELS_COUNT;
    const shownChannels = isAllShown ? channels : channels.slice(0, visibleChannelsCount);
    const firstHiddenChannel = !isAllShown ? channels[visibleChannelsCount] : undefined;
    const firstHiddenChannelId = firstHiddenChannel === null || firstHiddenChannel === void 0 ? void 0 : firstHiddenChannel.id;
    const lastShownChannelId = (_a = shownChannels[shownChannels.length - 1]) === null || _a === void 0 ? void 0 : _a.id;
    const showAllChannelsBtnId = 'show-all-channels-btn';
    return {
        channels: shownChannels,
        label: `${translate(labelKey || 'tvcomparison.channels')}`,
        count: channels.length,
        viewAllButton: channels.length > visibleChannelsCount && {
            text: isAllShown ? translate('tvcomparison.showLess.label') : `${translate('tvcomparison.showAll.label')} (+${channels.length - visibleChannelsCount})`,
            size: 'small',
            variant: 'secondary',
            id: showAllChannelsBtnId,
            onClick: async (event) => {
                await filterActions.toggleAllChannelsShown(event);
                focusAndScroll({
                    isAllShown,
                    firstHiddenChannelId,
                    lastShownChannelId,
                    showAllChannelsBtnId,
                });
            },
        },
    };
};
export const mapChannelsInfo = (channels, commonMapperProps) => {
    if (!(channels === null || channels === void 0 ? void 0 : channels.length)) {
        return {};
    }
    const resultMap = {};
    channels.forEach((channel) => (resultMap[channel.id] = mapChannelInfo(channel, commonMapperProps)));
    return resultMap;
};
const mapChannelInfo = (comparisonChannel, commonProps) => {
    var _a, _b;
    const audioOptions = (_a = comparisonChannel === null || comparisonChannel === void 0 ? void 0 : comparisonChannel.meta) === null || _a === void 0 ? void 0 : _a.find((meta) => {
        return meta.label === 'audio';
    });
    const subtitleOptions = (_b = comparisonChannel === null || comparisonChannel === void 0 ? void 0 : comparisonChannel.meta) === null || _b === void 0 ? void 0 : _b.find((meta) => {
        return meta.label === 'subtitles';
    });
    const srcset = (comparisonChannel === null || comparisonChannel === void 0 ? void 0 : comparisonChannel.images) && Object.values(comparisonChannel.images).join(', ');
    return {
        id: `tvcomparison-channel-id-${comparisonChannel === null || comparisonChannel === void 0 ? void 0 : comparisonChannel.id}-${commonProps.identifier}`,
        title: comparisonChannel === null || comparisonChannel === void 0 ? void 0 : comparisonChannel.title,
        description: (comparisonChannel === null || comparisonChannel === void 0 ? void 0 : comparisonChannel.description) || (comparisonChannel === null || comparisonChannel === void 0 ? void 0 : comparisonChannel.title),
        sound: (audioOptions === null || audioOptions === void 0 ? void 0 : audioOptions.value) || undefined,
        subTitles: (subtitleOptions === null || subtitleOptions === void 0 ? void 0 : subtitleOptions.value) || undefined,
        image: { srcset, role: 'presentation' },
        packetPrices: resolvePrices(comparisonChannel.prices, comparisonChannel.includedInPackage, commonProps, comparisonChannel.isPickableInPackage, comparisonChannel === null || comparisonChannel === void 0 ? void 0 : comparisonChannel.title, 'channel').reverse(),
        exclusiveLabel: commonProps.translate(`tvcomparison.channel.${comparisonChannel === null || comparisonChannel === void 0 ? void 0 : comparisonChannel.id}.exclusive.label`),
    };
};
